import Vue from "vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.component("fa", FontAwesomeIcon);

import { fas, faEuroSign, faDollarSign } from "@fortawesome/free-solid-svg-icons";
library.add(fas);
library.add(faEuroSign);
library.add(faDollarSign);
